module.exports = __webpack_public_path__ + "media/images/consumer/components/progress-bar/step-01@2x-ece8562a7124ffad9d9b0d0cc5be2ac5.webp";